import { render, staticRenderFns } from "./addUserBlack.vue?vue&type=template&id=7c89d6cc&scoped=true&"
import script from "./addUserBlack.vue?vue&type=script&lang=js&"
export * from "./addUserBlack.vue?vue&type=script&lang=js&"
import style0 from "./addUserBlack.vue?vue&type=style&index=0&id=7c89d6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89d6cc",
  null
  
)

export default component.exports